export enum PromotionGroupTypeEnum {
  NORMAL = 0,
  SIMPLE_WOW = 1,
  CIRCULAR_WOW = 3,
}
